import { useEffect, useRef } from "react";
import DOMPurify from "dompurify";
import { SHADOW_CSS_TEXT } from "../../../../utilities/CHAT_CSS";

const UniversalShadowWrapperV2 = ({ htmlContent, contentRef }) => {
  const hostRef = useRef(null);
  const shadowRef = useRef(null);

  useEffect(() => {
    if (!hostRef.current) return;

    if (!shadowRef.current) {
      shadowRef.current = hostRef.current.attachShadow({ mode: "open" });
    }

    const shadow = shadowRef.current;
    shadow.innerHTML = ""; // clear previous content

    // SAFE HTML
    const cleanHtml = DOMPurify.sanitize(
      typeof htmlContent === "string" ? htmlContent : ""
    );

    // STYLE TAG
    const styleTag = document.createElement("style");
    // styleTag.textContent = SHADOW_CSS_TEXT;
    styleTag.textContent = `${SHADOW_CSS_TEXT}
    .html-wrapper {
      user-select: text !important;
    }
  `;

    // WRAPPER
    const wrapper = document.createElement("div");
    wrapper.className = "html-wrapper";
    wrapper.innerHTML = cleanHtml;

    // Expose both HTML and CSS for printing
    wrapper.__shadowStyles = SHADOW_CSS_TEXT;

    if (typeof contentRef === "function") {
      contentRef(wrapper);
    }

    // Insert into shadow DOM
    shadow.appendChild(styleTag);
    shadow.appendChild(wrapper);
    const links = wrapper.querySelectorAll("a");
    links.forEach(a => {
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer");
    });
  }, [htmlContent, contentRef]);

  return <div ref={hostRef} />;
};

export default UniversalShadowWrapperV2;
